import { FC } from 'react'
import styles from './footer-nav-item.module.scss'
import IFooterNavItem from '@/types/footer-nav-item.interface'
import classNames from '@/utils/helpers/class-names.helper'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import useI18nPath from '@/hooks/i18n-path.hook'

type FooterNavItemProps = IFooterNavItem & {}

const FooterNavItem: FC<FooterNavItemProps> = ({ children, className, titleI18n, url }) => {
  const { t } = useTranslation()
  const { getHrefLang } = useI18nPath()

  return (
    <li className={classNames(className, styles.item)}>
      {children ? (
        children
      ) : (
        <>
          {url ? (
            <Link
              itemProp="url"
              className={classNames(styles.link, className)}
              href={getHrefLang(url)}
            >
              {t(titleI18n || '')}
            </Link>
          ) : (
            t(titleI18n || '')
          )}
        </>
      )}
    </li>
  )
}

export default FooterNavItem
